module.exports = __webpack_public_path__ + "static/media/Floor002-04-01.58bd0bab.png";